import { Component, Input, OnInit } from '@angular/core';
import { Delivery, StatusButtons } from "../../../../_shared/interfaces";
import { AlertService, DeliveryStoreService, IAlertType } from "../../../../_shared/services";
import { NgForOf, NgIf } from "@angular/common";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-job-details-deliveries',
  standalone: true,
  imports: [
    NgIf,
    RouterLink,
    NgForOf
  ],
  templateUrl: './job-details-deliveries.component.html',
  styleUrl: './job-details-deliveries.component.sass'
})
export class JobDetailsDeliveriesComponent implements OnInit {
  deliveries: Delivery[] = [];
  projectid: string = '';
  loading: boolean = true;
  statusLabel = 'label-light-blue';
  statusText = '';

  @Input() delprid: string = '';
  @Input() delposid: string = '';
  @Input() delpartid: number = 0;
  @Input() jobid: number = 0;
  @Input() deliveryID: number = 0;
  @Input() posList: boolean = true;

  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Offen', label: 'label-light-blue', icon: 'info-circle'},
    { state: 'closed', display: 'Gebucht', label: 'label-success', icon: 'info-circle'},
    { state: 'noinvoice', display: 'Ohne Rechnung', label: 'label-warning', icon: 'exclamation-triangle'}
  ];

  constructor(
    private delss: DeliveryStoreService,
    private alertDispatcher: AlertService,
  ) { }

  ngOnInit(): void {
    this.loadDeliveryPositions(this.delprid, this.jobid, this.deliveryID, this.delposid, this.delpartid.toString());
  }

  loadDeliveryPositions(projectid: string, jobid: number, deliveryid: number, position: string, part: string) {
    this.delss.getDeliveryPositions(projectid, jobid, deliveryid, position, part).subscribe({
      next: data1 => {
        if (!data1 || data1.hasErrors || !data1.message) {
          this.alertDispatcher.alertConfig.message += ' Order konnte nicht erstellt werden! ';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.deliveries = data1.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    })
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  getCellStatus(status: string) {
    // findButtonStatus liefert -1, wenn der Status unbekannt ist -- ein
    // direkter Zugriff darauf wirft und reisst die ganze Tabelle mit.
    const treffer = this.statusButtons[this.findButtonStatus(status, this.statusButtons)];
    return {
      'statusLabel': treffer?.label ?? 'label-light-blue',
      'statusDisplay': treffer?.display ?? status,
      'statusIcon': treffer?.icon ?? 'info-circle'
    };
  }

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus).statusLabel + " alert-sm";
  }
}
